import * as actionTypes from "./constants";

export function login(cred) {
  return {
    type: actionTypes.LOGIN_INIT_ACTION,
    cred: cred,
  };
}

export function logOut() {
  return {
    type: actionTypes.LOGOUT_ACTION,
  };
}

export function getUnit(value) {
  return {
    type: actionTypes.GETUNIT_ACTION,
    value: value,
  };
}

// export function fetchStatus(value) {

//   return {
//     type: actionTypes.FETCH_CHECKSTATUS_INIT_ACTION,
//     value: value

//   };
// }

// const login = (params) => {
//   return (dispatch) => {
//     dispatch({
//       type: actionTypes.LOGIN_INIT_ACTION,
//       params: params,
//     });
//   };
// };

// const logOut = () => {
//   return (dispatch) => {
//     dispatch({
//       type: actionTypes.LOGOUT_ACTION,
//     });
//   };
// };

// const fetchStatus = (id) => {
//   return (dispatch) => {
//     dispatch({
//       type: actionTypes.FETCH_CHECKSTATUS_INIT_ACTION,
//       param: id,
//     });
//   };
// };

// export default {
//   login,
//   logOut,
//   fetchStatus,
// };
